<nav class=" navbar navbar-expand-md custom-m text-center nav-theme"  [ngClass]="themeClass('nav-section1')">
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavAltMarkup"
        aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
        <ng-container *ngFor="let item of headerdata.firstRow">
            <div class="navbar-nav position-relative red-b cursor-pointer" [class.has-children]="item.load_child_menus?.length > 0"
                 routerLinkActive="active-red">
                <div *ngIf="item?.menu_style=='Panel Roll Down'" [routerLink]="item.menu_link" >
                    <img [src]="cdnImagePath+item?.menu_image" alt="menu image">
                </div>
                <a class="nav-link nav-item cursor-pointer" *ngIf="item.menu_name =='SHOP BY VEHICLE'" (click)="openVechiclePopup()">
                    {{ item.menu_name }}
                </a>
                <a class="nav-link nav-item" [routerLink]="item.menu_link" routerLinkActive="active" 
                *ngIf="item.menu_name !='SHOP BY VEHICLE'">
                    {{ item.menu_name }}
                </a>
                <div class="drop-navmenu">
                    <li *ngFor="let child of item.load_child_menus">
                        <a [routerLink]="child.menu_link" routerLinkActive="active" class="list-service">{{
                            child.menu_name }}</a>
                    </li>
                </div>
            </div>
        </ng-container>
    </div>
</nav>